import Vue from "vue";
import Vuex from "vuex";
import jwtDecode from "jwt-decode";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null, // 初始化 token 为 null
  },
  getters: {
    getToken(state) {
      return this.state.token;
    },
  },
  mutations: {
    LOGIN_IN(state, token) {
      // 保存 token 到 state
      state.token = token;
      // 将 token 保存到 localStorage
      localStorage.setItem("token", token);

      // 如果需要，您可以在这里解析 token 并更新 user 状态
       let user = jwtDecode(token); // 假设您使用 jwt_decode 来解析 token          
       let userInfo = {  
        user: '',  
        unit: ''  
      }; 
       userInfo.user=user.username;
       userInfo.unit=user.unit_name;
       localStorage.setItem("userInfo", JSON.stringify(userInfo));
    },
    LOGIN_OUT(state) {
      // 清除 token 和 user 状态
      state.token = null;
      // 从 localStorage 移除 token
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
    },
  },
  actions: {},
  modules: {},
});
